import { motion, Variants } from "framer-motion";
import { memo } from "react";

const barVariants: Variants = {
    initial: {
        scaleY: 0.5,
        opacity: 0,
    },
    animate: {
        scaleY: 1,
        opacity: 1,
        transition: {
            repeat: Infinity,
            repeatType: "mirror",
            duration: 1,
            ease: "circIn",
        },
    },
};

export const BarLoader = memo(() => {
    const bars = Array(5).fill(0); 

    return (
        <motion.div
            transition={{
                staggerChildren: 0.25,
            }}
            initial="initial"
            animate="animate"
            className="flex gap-1"
            role="status"
            aria-live="polite"
        >
            {bars.map((_, index) => (
                <motion.div
                    key={index}
                    variants={barVariants}
                    className="h-12 w-2 bg-secondary-light"
                />
            ))}
        </motion.div>
    );
});